import { render, staticRenderFns } from "./QuizSoloResultText.vue?vue&type=template&id=2a4538c2&scoped=true&"
import script from "./QuizSoloResultText.vue?vue&type=script&lang=js&"
export * from "./QuizSoloResultText.vue?vue&type=script&lang=js&"
import style0 from "./QuizSoloResultText.vue?vue&type=style&index=0&id=2a4538c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4538c2",
  null
  
)

export default component.exports